import { useContext } from "react";
import { ExpressDeliveryCartContext } from "../providers/express-delivery-cart";

export default function useExpressDeliveryCart() {
  return useContext(ExpressDeliveryCartContext);
}
